import type { Dict } from "../lib/i18n";

// Keys are prefixed "community." — keep zh / en / nl in step.
export default {
  zh: {
    "community.comments.needText": "请先写回复内容",
    "community.comments.needAck": "请先勾选上面这一项：回复所有同城邻居都能看到",
    "community.title": "邻里分享",
    "community.eyebrow": "同城邻里",
    "community.heroSub": "和同城邻居分享美食、优惠、工作和互助信息。",
    "community.changeCity": "更换城市（当前：{place}）",
    "community.noRegion.title": "先选择你所在的城市",
    "community.noRegion.body": "邻里分享按城市划分，你只会看到同城邻居发的帖子。",
    "community.chooseCity": "选择城市",
    "community.refresh": "刷新",
    "community.newPost": "发帖",
    "community.categories": "分类",
    "community.cat.all": "全部",
    "community.cat.food": "美食",
    "community.cat.shopping": "购物优惠",
    "community.cat.work": "工作",
    "community.cat.help": "互助",
    "community.cat.books": "图书",
    "community.empty.title": "这里还没有帖子",
    "community.empty.body": "来发第一条吧，比如附近的优惠，或者想送出去的食物。",
    "community.empty.category": "这个分类下暂时没有帖子。",
    "community.more": "更多帖子",
    "community.neighbour": "邻居",
    "community.you": "我发的",
    "community.hiddenPill": "因举报已隐藏",
    "community.hiddenNote": "这条帖子被多位邻居举报，其他人已经看不到了。",
    "community.endsOn": "{date} 截止",
    "community.ended": "已结束",
    "community.replies": "回复 · {n}",
    "community.reply": "回复",
    "community.options": "帖子选项",
    "community.report": "举报",
    "community.reported": "已举报",
    "community.delete": "删除帖子",
    "community.delete.title": "删除这条帖子？",
    "community.delete.body": "帖子和所有回复都会被删除，无法恢复。",
    "community.deleted": "帖子已删除",
    "community.cannotReportOwn": "不能举报自己发的内容。",
    "community.rateLimit": "你刚才发得有点多，休息一下，过一会儿再发吧。",

    "community.report.title": "举报这条帖子",
    "community.report.intro": "这条帖子有什么问题？被三位邻居举报后，帖子会自动隐藏。",
    "community.report.reason": "原因",
    "community.reason.privacy": "泄露个人隐私",
    "community.reason.abuse": "辱骂或骚扰",
    "community.reason.spam": "垃圾信息或广告",
    "community.reason.misleading": "虚假或误导",
    "community.report.send": "提交举报",
    "community.report.thanks": "谢谢，我们已收到你的举报。",

    "community.compose.title": "发一条帖子",
    "community.compose.where": "发布到 {place}",
    "community.compose.category": "分类",
    "community.compose.titleField": "标题",
    "community.compose.body": "内容",
    "community.compose.bodyHint": "写清楚地点和时间，但不要留下住址、电话等个人信息。",
    "community.compose.alias": "显示名称",
    "community.compose.aliasHint": "不填则显示为“邻居”。",
    "community.compose.endsOn": "截止日期",
    "community.compose.endsOnHint": "比如优惠结束的日期。",
    "community.compose.ack": "我知道这条帖子对 {city} 的所有人公开。",
    "community.compose.publish": "发布",
    "community.compose.posted": "已发布",
    "community.compose.needAck": "请先勾选确认帖子是公开的。",
    "community.compose.needBody": "请先写点内容。",
    "community.compose.ackKnown": "帖子对 {city} 的所有人公开。",
    "community.counter": "{n}/{max}",

    "community.comments.title": "回复",
    "community.comments.empty": "还没有回复，来说第一句吧。",
    "community.comments.text": "你的回复",
    "community.comments.ack": "我知道回复是公开的。",
    "community.comments.send": "发送回复",
    "community.comments.sent": "已回复",
    "community.comments.delete": "删除回复",
    "community.comments.confirmDelete": "删除这条回复？",
    "community.comments.deleted": "回复已删除",
    "community.comments.closed": "这条帖子已被隐藏，不能再回复。",

    "community.region.title": "你所在的城市",
    "community.region.locate": "用我的位置",
    "community.region.locateHint": "位置会先四舍五入到约 1 公里，只用来查出你所在的城市。我们只保存城市名称。",
    "community.region.manual": "或者手动填写",
    "community.region.country": "国家",
    "community.region.city": "城市",
    "community.region.found": "找到了：{place}。点“保存”即可使用。",
    "community.region.unsupported": "邻里分享暂未开通你所在的国家，请从列表中选择。",
    "community.region.noCity": "没能识别出城市，请手动输入。",
    "community.region.denied": "没有定位权限。请在下面手动填写，或在浏览器设置中允许定位。",
    "community.region.failed": "暂时无法获取位置，请在下面手动填写。",

    "community.rules.title": "社区守则",
    "community.rules.public": "帖子对同城所有人公开，7 天后自动删除。",
    "community.rules.private": "不要分享住址、电话、证件号码等个人信息。",
    "community.rules.reports": "被三位邻居举报的内容会自动隐藏。",
  },
  en: {
    "community.comments.needText": "Write your reply first",
    "community.comments.needAck": "Please tick the box above first: everyone nearby can see replies",
    "community.title": "Neighbourhood board",
    "community.eyebrow": "Your neighbourhood",
    "community.heroSub": "Share food, deals, jobs and a helping hand with people in your city.",
    "community.changeCity": "Change city (now {place})",
    "community.noRegion.title": "Choose your city first",
    "community.noRegion.body": "The board is organised by city: you'll see posts from neighbours in the same city.",
    "community.chooseCity": "Choose city",
    "community.refresh": "Refresh",
    "community.newPost": "Write a post",
    "community.categories": "Categories",
    "community.cat.all": "All",
    "community.cat.food": "Food",
    "community.cat.shopping": "Deals",
    "community.cat.work": "Work",
    "community.cat.help": "Help",
    "community.cat.books": "Books",
    "community.empty.title": "No posts yet",
    "community.empty.body": "Be the first: share a deal nearby, or food you'd like to give away.",
    "community.empty.category": "Nothing in this category yet.",
    "community.more": "More posts",
    "community.neighbour": "Neighbour",
    "community.you": "You",
    "community.hiddenPill": "Hidden after reports",
    "community.hiddenNote": "Several neighbours reported this post, so others can no longer see it.",
    "community.endsOn": "Ends on {date}",
    "community.ended": "Ended",
    "community.replies": "Replies · {n}",
    "community.reply": "Reply",
    "community.options": "Post options",
    "community.report": "Report",
    "community.reported": "Reported",
    "community.delete": "Delete post",
    "community.delete.title": "Delete this post?",
    "community.delete.body": "The post and all its replies will be removed. This can't be undone.",
    "community.deleted": "Post deleted",
    "community.cannotReportOwn": "You can't report your own posts.",
    "community.rateLimit": "You've posted quite a lot just now. Take a short break and try again later.",

    "community.report.title": "Report this post",
    "community.report.intro": "What's wrong with it? A post is hidden automatically once three neighbours report it.",
    "community.report.reason": "Reason",
    "community.reason.privacy": "Shares private details",
    "community.reason.abuse": "Abusive or harassing",
    "community.reason.spam": "Spam or advertising",
    "community.reason.misleading": "False or misleading",
    "community.report.send": "Send report",
    "community.report.thanks": "Thanks, we've received your report.",

    "community.compose.title": "New post",
    "community.compose.where": "Posting to {place}",
    "community.compose.category": "Category",
    "community.compose.titleField": "Title",
    "community.compose.body": "Message",
    "community.compose.bodyHint": "Say where and when, but leave out your address, phone number and other private details.",
    "community.compose.alias": "Display name",
    "community.compose.aliasHint": "Leave empty to show “Neighbour”.",
    "community.compose.endsOn": "End date",
    "community.compose.endsOnHint": "For example, when an offer ends.",
    "community.compose.ack": "I understand this post is public to everyone in {city}.",
    "community.compose.publish": "Publish",
    "community.compose.posted": "Posted",
    "community.compose.needAck": "Please tick the box to confirm the post is public.",
    "community.compose.needBody": "Please write something first.",
    "community.compose.ackKnown": "Posts are public to everyone in {city}.",
    "community.counter": "{n}/{max}",

    "community.comments.title": "Replies",
    "community.comments.empty": "No replies yet. Start the conversation.",
    "community.comments.text": "Your reply",
    "community.comments.ack": "I understand this is public.",
    "community.comments.send": "Send reply",
    "community.comments.sent": "Reply posted",
    "community.comments.delete": "Delete reply",
    "community.comments.confirmDelete": "Delete this reply?",
    "community.comments.deleted": "Reply deleted",
    "community.comments.closed": "This post is hidden, so new replies are closed.",

    "community.region.title": "Your city",
    "community.region.locate": "Use my location",
    "community.region.locateHint": "Your location is rounded to about 1 km and only used to look up your city. We only save the city name.",
    "community.region.manual": "Or fill it in yourself",
    "community.region.country": "Country",
    "community.region.city": "City",
    "community.region.found": "Found {place}. Tap Save to use it.",
    "community.region.unsupported": "The board isn't available in your country yet. Please choose one from the list.",
    "community.region.noCity": "We couldn't tell which city you're in. Please type it in.",
    "community.region.denied": "Location access is off. Fill in your city below, or allow location in your browser settings.",
    "community.region.failed": "Couldn't get your location. Please fill in your city below.",

    "community.rules.title": "Board rules",
    "community.rules.public": "Posts are public to people in the same city and are deleted after 7 days.",
    "community.rules.private": "Don't share private details such as your address, phone number or ID.",
    "community.rules.reports": "Anything reported by three neighbours is hidden automatically.",
  },
  nl: {
    "community.comments.needText": "Schrijf eerst je reactie",
    "community.comments.needAck": "Vink eerst het vakje hierboven aan: iedereen in de buurt ziet reacties",
    "community.title": "Buurtprikbord",
    "community.eyebrow": "Jouw buurt",
    "community.heroSub": "Deel eten, aanbiedingen, werk en hulp met mensen in je stad.",
    "community.changeCity": "Stad wijzigen (nu {place})",
    "community.noRegion.title": "Kies eerst je stad",
    "community.noRegion.body": "Het prikbord is per stad: je ziet berichten van buren in dezelfde stad.",
    "community.chooseCity": "Stad kiezen",
    "community.refresh": "Vernieuwen",
    "community.newPost": "Bericht plaatsen",
    "community.categories": "Categorieën",
    "community.cat.all": "Alles",
    "community.cat.food": "Eten",
    "community.cat.shopping": "Winkelen",
    "community.cat.work": "Werk",
    "community.cat.help": "Hulp",
    "community.cat.books": "Boeken",
    "community.empty.title": "Nog geen berichten",
    "community.empty.body": "Wees de eerste: deel een aanbieding in de buurt, of eten dat je wilt weggeven.",
    "community.empty.category": "Nog niets in deze categorie.",
    "community.more": "Meer berichten",
    "community.neighbour": "Buur",
    "community.you": "Jij",
    "community.hiddenPill": "Verborgen na meldingen",
    "community.hiddenNote": "Meerdere buren hebben dit bericht gemeld, dus anderen zien het niet meer.",
    "community.endsOn": "Loopt tot {date}",
    "community.ended": "Afgelopen",
    "community.replies": "Reacties · {n}",
    "community.reply": "Reageren",
    "community.options": "Opties voor bericht",
    "community.report": "Melden",
    "community.reported": "Gemeld",
    "community.delete": "Bericht verwijderen",
    "community.delete.title": "Dit bericht verwijderen?",
    "community.delete.body": "Het bericht en alle reacties worden verwijderd. Dit kun je niet ongedaan maken.",
    "community.deleted": "Bericht verwijderd",
    "community.cannotReportOwn": "Je kunt je eigen berichten niet melden.",
    "community.rateLimit": "Je hebt net best veel geplaatst. Neem even pauze en probeer het straks opnieuw.",

    "community.report.title": "Dit bericht melden",
    "community.report.intro": "Wat is er mis mee? Een bericht wordt automatisch verborgen zodra drie buren het melden.",
    "community.report.reason": "Reden",
    "community.reason.privacy": "Deelt privégegevens",
    "community.reason.abuse": "Beledigend of intimiderend",
    "community.reason.spam": "Spam of reclame",
    "community.reason.misleading": "Onjuist of misleidend",
    "community.report.send": "Melding versturen",
    "community.report.thanks": "Bedankt, we hebben je melding ontvangen.",

    "community.compose.title": "Nieuw bericht",
    "community.compose.where": "Plaatsen in {place}",
    "community.compose.category": "Categorie",
    "community.compose.titleField": "Titel",
    "community.compose.body": "Bericht",
    "community.compose.bodyHint": "Vertel waar en wanneer, maar laat je adres, telefoonnummer en andere privégegevens weg.",
    "community.compose.alias": "Schermnaam",
    "community.compose.aliasHint": "Laat leeg om “Buur” te tonen.",
    "community.compose.endsOn": "Einddatum",
    "community.compose.endsOnHint": "Bijvoorbeeld wanneer een aanbieding afloopt.",
    "community.compose.ack": "Ik begrijp dat dit bericht openbaar is voor iedereen in {city}.",
    "community.compose.publish": "Plaatsen",
    "community.compose.posted": "Geplaatst",
    "community.compose.needAck": "Vink het vakje aan om te bevestigen dat het bericht openbaar is.",
    "community.compose.needBody": "Schrijf eerst iets.",
    "community.compose.ackKnown": "Berichten zijn openbaar voor iedereen in {city}.",
    "community.counter": "{n}/{max}",

    "community.comments.title": "Reacties",
    "community.comments.empty": "Nog geen reacties. Begin het gesprek.",
    "community.comments.text": "Je reactie",
    "community.comments.ack": "Ik begrijp dat dit openbaar is.",
    "community.comments.send": "Reactie plaatsen",
    "community.comments.sent": "Reactie geplaatst",
    "community.comments.delete": "Reactie verwijderen",
    "community.comments.confirmDelete": "Deze reactie verwijderen?",
    "community.comments.deleted": "Reactie verwijderd",
    "community.comments.closed": "Dit bericht is verborgen, dus reageren kan niet meer.",

    "community.region.title": "Jouw stad",
    "community.region.locate": "Mijn locatie gebruiken",
    "community.region.locateHint": "Je locatie wordt afgerond op ongeveer 1 km en alleen gebruikt om je stad op te zoeken. We bewaren alleen de naam van de stad.",
    "community.region.manual": "Of vul het zelf in",
    "community.region.country": "Land",
    "community.region.city": "Stad",
    "community.region.found": "{place} gevonden. Tik op Opslaan om die te gebruiken.",
    "community.region.unsupported": "Het prikbord is nog niet beschikbaar in jouw land. Kies een land uit de lijst.",
    "community.region.noCity": "We konden niet zien in welke stad je bent. Vul hem zelf in.",
    "community.region.denied": "Locatietoegang staat uit. Vul hieronder je stad in, of sta locatie toe in je browserinstellingen.",
    "community.region.failed": "Je locatie kon niet worden bepaald. Vul hieronder je stad in.",

    "community.rules.title": "Spelregels",
    "community.rules.public": "Berichten zijn openbaar voor mensen in dezelfde stad en worden na 7 dagen verwijderd.",
    "community.rules.private": "Deel geen privégegevens zoals je adres, telefoonnummer of ID.",
    "community.rules.reports": "Wat door drie buren is gemeld, wordt automatisch verborgen.",
  },
} satisfies Dict;
